import { FragaProduct } from '@/core/domain/operational/Fraga/Fraga.types';
import React, { useContext, useEffect, useState } from 'react';

export interface FragePartsContextParams {
  fragaParts: FragaProduct[];
  setFragaParts: React.Dispatch<React.SetStateAction<FragaProduct[]>>;
  currentPart: number;
  setCurrentPart: React.Dispatch<React.SetStateAction<number>>;
}

interface Props {
  children: React.ReactNode;
}

const FragaPartsContext = React.createContext({} as FragePartsContextParams);

export const useFragaPartsContext = () => useContext(FragaPartsContext);

const FragaPartsProvider: React.FC<Props> = (props: Props) => {
  const [fragaParts, setFragaParts] = useState<FragaProduct[]>([]);
  const [currentPart, setCurrentPart] = useState(0);

  useEffect(() => {
    return () => setFragaParts([]);
  }, []);

  return (
    <FragaPartsContext.Provider
      value={{ fragaParts, setFragaParts, currentPart, setCurrentPart }}
    >
      {props.children}
    </FragaPartsContext.Provider>
  );
};

export default FragaPartsProvider;
